import { render } from "./IconLight.vue?vue&type=template&id=380e979d&ts=true"
import script from "./IconLight.vue?vue&type=script&lang=ts"
export * from "./IconLight.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__